import forIn from 'lodash/forIn';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import cn from 'clsx';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select, { components } from 'react-select';
import dynamic from 'next/dynamic';
import debounce from 'lodash/debounce';
import { withRouter } from 'next/router';
import {
  changeOrder,
  changePage,
  changePerPage,
  searchPhoto,
  changePersonalize,
  searchOtherServices,
  changeToggleFilterSearch,
} from './actions';
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectOrderBy,
  makeSelectPage,
  makeSelectPerPage,
  makeSelectPhotos,
  makeSelectQuery,
  makeSelectTotalItem,
  makeSelectTotalPage,
  makeSelectHasNext,
  makeSelectHasPersonalize,
  makeSelectOtherServices,
  makeSelectSuggestion,
} from './selectors';
import OtherServices from './OtherServices';
import OtherKeywords from './OtherKeywords';
import { makeSelectCurrentLang } from '../MetadataProvider/selectors';
import { loadDataSearch } from '../Search/actions';
import { loadingShow, loadingHide } from '../Loading/actions';
import { selectSearch } from '~/containers/Search/selectors';
import {
  makeSelectCategories,
  makeSelectToggleFilterSearch,
} from '~/containers/Search/selectors';
import Link from '~/components/I18nLink';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import NextPageButtonCustom from '~/components/NextPageButtonCustom';
import PaginationNew from '~/components/PaginationNew';
import Config, { keyConfig } from '~/config';
import { makeSelectPatterns } from '~/containers/HomePage/selectors';
import { makeSelectCurrentLanguage } from '~/containers/Language/selectors';
import RefineSearch from '~/containers/Search/RefineSearch/Loadable';
// import RefineSearchNew from '~/containers/Search/RefineSearchNew/Loadable';
import IconFilter from '~/components/svg/icon-filter.svg';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';
import LocalStorage from '~/services/LocalStorage';
import themeVariables from '~/shared/themeVariables';
import TagTrending from '~/components/TagTrending';
import { makeSelectIsCountdownActive } from '~/containers/PaymentModal/selectors';
import BannerDiscount from '~/components/BannerDiscount';
import { SEARCH_RESULT_ORDER } from '~/utils/constants';
import { loadPhotosInCart } from '~/containers/Layout/actions';
import { urls } from '~/utils';
import I18nLink from '~/components/I18nLink';
import { makeSelectIsShowFilterOnHeader } from '~/containers/Layout/selectors';
import {
  closeAllFilter,
  openAllFilter,
  changeOpenMore,
} from '~/containers/Search/actions';
import Banner from '~/components/Banner';
import NewSurvey from '~/components/NewSurvey';
import PaginationStaticPage from '~/components/PaginationStaticPage';

const Gallery = dynamic(() => import('~/components/Gallery'));
const GalleryIllust = dynamic(() =>
  import('~/components/Gallery/GalleryIllust'),
);
const PreviousPageButtonCustom = dynamic(() =>
  import('~/components/PreviousPageButtonCustom'),
);
const RefineSearchNew = dynamic(() =>
  import('~/containers/Search/RefineSearchNew'),
);

const roles = Config.getRoles();
@withRouter
class SearchResultContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      topPosition: 70,
      perPage: null,
      isTabletS: false,
      isCallOtherService: false,
    };
    this.galleryRef = React.createRef();
    this.filterBarRef = React.createRef();
    this.photoContainerRef = React.createRef();
    this.checkIsTabletS = this.checkIsTabletS.bind(this);
    this._checkIsTabletS = debounce(this.checkIsTabletS, 200);
  }

  componentDidMount() {
    const { query, photos } = this.props;
    this.updateSearchFilters();
    if (Config.isDesignAC()) {
      this.props.onToggleFilterSearch(false);
      LocalStorage.hideFilter = false;
    } else {
      if (window.innerWidth >= 600) {
        this.props.onToggleFilterSearch(!LocalStorage.hideFilter);
      } else {
        this.props.onToggleFilterSearch(false);
      }
    }
    window.addEventListener('scroll', this.onScroll);
    if (photos.length < 1) {
      this.props.onToggleFilterSearch(false);
    }
    if (window.innerWidth <= themeVariables.breakpoints.mobile.maxWidth) {
      this.setState({ isTabletS: true });
    } else {
      this.setState({ isTabletS: false });
      // Search filter Illust: hidden filter search default for illust
      if (Config.isIllustAC()) {
        this.handleChangeToggleFilterSearch(false);
      }
    }
    window.addEventListener('resize', this._checkIsTabletS);
    window.addEventListener('scroll', this.onCallOtherService);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._checkIsTabletS);
    window.removeEventListener('scroll', this.onCallOtherService);
  }

  componentDidUpdate(prevProps) {
    const { searchType, loading, query, loadPhotosInCart, photos } = this.props;
    loadPhotosInCart();

    if (prevProps.query !== query) {
      this.updateSearchFilters();
      // this.props.searchOtherServices(query);
      this.setState({
        isCallOtherService: false,
      });
    }
    if (searchType == 'byPhoto' && !loading) {
      this.props.loadingHide();
    }
  }

  onCallOtherService = () => {
    const { isCallOtherService } = this.state;
    const { query, searchOtherServices } = this.props;

    if (!isCallOtherService && this.photoContainerRef?.current) {
      if (window.scrollY > this.photoContainerRef.current.clientHeight / 2) {
        console.log('vo day neeeee!!!', query);
        searchOtherServices(query);

        this.setState({
          isCallOtherService: true,
        });
      }
    }
  };

  checkIsTabletS() {
    if (window.innerWidth <= themeVariables.breakpoints.mobile.maxWidth) {
      this.setState({ isTabletS: true });
      // Search filter Illust: handle for search filter IllustAC
      if (Config.isIllustAC()) {
        this.props.openAllFilter();
      }
    } else {
      this.setState({ isTabletS: false });
      // Search filter Illust: handle for search filter IllustAC
      if (Config.isIllustAC()) {
        this.props.closeAllFilter();
      }
    }
  }

  updateSearchFilters = () => {
    const { t, query } = this.props;
    const category = [];
    const excludeCategory = [];
    let modelAge = [];
    const { categories } = this.props;
    const dataModelAge = [];
    const modelAgeOption = [
      {
        label: t('baby'),
        value: 'A',
      },
      {
        label: t('children'),
        value: 'K',
      },
      {
        label: t('youth'),
        value: 'W',
      },
      {
        label: t('grown_up'),
        value: 'O',
      },
      {
        label: t('middle_aged'),
        value: 'C',
      },
      {
        label: t('senior_citizens'),
        value: 'S',
      },
    ];
    if (query.category) {
      const categoryIds = query.category.split(',');
      categoryIds.map((id) =>
        category.push(categories.find((item) => item.value == id)),
      );
    }

    if (query.excludeCategory) {
      const categoryIds = query.excludeCategory.split(',');
      categoryIds.map((id) =>
        excludeCategory.push(categories.find((item) => item.value == id)),
      );
    }
    if (query.modelAge) {
      modelAge = query.modelAge.split(',');
      modelAge.map((id) =>
        dataModelAge.push(modelAgeOption.find((item) => item.value == id)),
      );
    }
    const tmpDataNow = [];
    if (category && category.length > 0) {
      const data = category.map((element) => ({
        ...element,
        type: 'category',
        label: t('include_keyword') + ': ' + element.label,
      }));
      tmpDataNow.push(...data);
    }
    if (excludeCategory && excludeCategory.length > 0) {
      const data = excludeCategory.map((element) => ({
        ...element,
        type: 'excludeCategory',
        label: t('exclude_keyword') + ': ' + element.label,
      }));
      tmpDataNow.push(...data);
    }
    if (query.creatorName && query.creatorName !== '') {
      tmpDataNow.push({
        label: t('creator_name') + ': ' + query.creatorName,
        type: 'creatorName',
      });
    }
    if (query.excludeCreatorName && query.excludeCreatorName !== '') {
      tmpDataNow.push({
        label: query.excludeCreatorName,
        type: 'excludeCreatorName',
      });
    }
    if (query.imageType && query.imageType !== '') {
      let labelImage = '';
      switch (query.imageType) {
        case 'vector':
          labelImage = 'EPS・AI';
          break;
        case 'png':
          labelImage = 'PNG';
          break;
        case 'psd':
          labelImage = 'PSD';
          break;
        case 'medium':
          labelImage = 'M';
          break;
        case 'large':
          labelImage = 'L';
          break;
      }
      tmpDataNow.push({
        label: 'Image Type' + ': ' + labelImage,
        type: 'imageType',
      });
    }
    if (query.orderBy && query.orderBy !== SEARCH_RESULT_ORDER.ALL_IMAGES) {
      const dataTmp = {
        type: 'orderBy',
        value: query.orderBy,
        label:
          query.orderBy === SEARCH_RESULT_ORDER.POPULAR
            ? t('popular')
            : query.orderBy === SEARCH_RESULT_ORDER.NEWEST
            ? t('recent')
            : t('all_images'),
      };
      tmpDataNow.push(dataTmp);
    }
    if (query.shape && query.shape !== 'all') {
      const dataTmp = {
        type: 'shape',
        value: query.shape,
        label:
          t('shape') +
          ': ' +
          (query.shape === 'vertical'
            ? t('Vertical')
            : query.shape === 'horizontal'
            ? t('Horizontal')
            : t('all')),
      };
      tmpDataNow.push(dataTmp);
    }
    if (query.imageId && query.imageId !== '') {
      tmpDataNow.push({ label: 'ID' + ': ' + query.imageId, type: 'imageId' });
    }
    if (query.imageTitle && query.imageTitle !== '') {
      tmpDataNow.push({
        label: t('title') + ': ' + query.imageTitle,
        type: 'imageTitle',
      });
    }
    if (query.color && query.color !== 'all') {
      tmpDataNow.push({ label: query.color, type: 'color' });
    }
    if (query.modelCount && query.modelCount !== '-2') {
      const dataTmp = {
        type: 'modelCount',
        value: query.modelCount,
        label:
          query.modelCount === '-2'
            ? t('all')
            : query.modelCount === '0'
            ? t('count_people_0')
            : query.modelCount === '1'
            ? t('count_people_1')
            : query.modelCount === '2'
            ? t('count_people_2')
            : t('count_people_3'),
      };
      tmpDataNow.push(dataTmp);
    }
    if (dataModelAge && dataModelAge.length > 0) {
      const data = dataModelAge.map((element) => ({
        ...element,
        type: 'modelAge',
      }));
      tmpDataNow.push(...data);
    }
    if (query.excludeKeyword && query.excludeKeyword !== '') {
      tmpDataNow.push({
        label: t('Excuse keyword') + ': ' + query.excludeKeyword,
        type: 'excludeKeyword',
      });
    }
    if (query.orientation && query.orientation !== '') {
      tmpDataNow.push({
        label: query.orientation,
        type: 'orientation',
      });
    }
    if (query.keyword && query.keyword !== '') {
      tmpDataNow.push({
        label: query.keyword,
        type: 'keyword',
      });
    }
    if (query.license && query.license !== '') {
      tmpDataNow.push({
        type: 'license',
        label:
          query.license === '0'
            ? t('without_extra_licenses')
            : t('extra_licenses'),
      });
    }
    if (query.modelRelease && query.modelRelease !== '') {
      const modelRelease = query.modelRelease;

      const labelTmp =
        modelRelease === '0'
          ? t('model_releases_only')
          : modelRelease === '1'
          ? t('property_releases_only')
          : modelRelease === '2'
          ? t('without_releases')
          : '';

      tmpDataNow.push({
        type: 'modelRelease',
        label: labelTmp,
      });
    }

    this.props.loadDataSearch({
      ...query,
      category,
      excludeCategory,
      modelAge: dataModelAge,
      dataNow: tmpDataNow,
    });
  };

  onNextPage = () => {
    let currentPage = this.props.page;
    if (currentPage >= this.props.totalPage) {
      return {};
    }
    currentPage++;

    let asPath = `page=${currentPage}`;
    forIn(this.props.query, (value, key) => {
      if (
        value &&
        key !== 'page' &&
        key !== 'is_tag' &&
        key !== 'clientIp' &&
        key !== 'keyword'
      ) {
        asPath += `&${key}=${value}`;
      }
    });

    return {
      as: `/search/${this.props.query.keyword}?${asPath}`,
      query: { ...this.props.query, page: currentPage, is_tag: true },
    };
  };
  onPreviousPage = () => {
    let currentPage = this.props.page;
    currentPage--;

    let asPath = `page=${currentPage}`;
    forIn(this.props.query, (value, key) => {
      if (
        value &&
        key !== 'page' &&
        key !== 'is_tag' &&
        key !== 'clientIp' &&
        key !== 'keyword'
      ) {
        asPath += `&${key}=${value}`;
      }
    });

    return {
      as: `/search/${this.props.query.keyword}?${asPath}`,
      query: { ...this.props.query, page: currentPage, is_tag: true },
    };
  };
  onChangePage = (page) => {
    this.props.changePage(page);
  };

  handleChangeToggleFilterSearch = (value) => {
    this.props.onToggleFilterSearch(value);
    LocalStorage.hideFilter = !value;
  };

  // TODO: Get parameters from props
  renderNavigationAndBreadCrumb(t, currentLanguage) {
    const { suggestion, toggleFilterSearch, router } = this.props;
    const isSearchResultImage =
      router.pathname.indexOf('/search-result') !== -1;
    // const pageText = t('page_text', { page });
    const refineSearchClassName = cn(
      'nav-menu-item',
      'refine-search',
      Config.serviceType,
      {
        'nav-menu-item-active': toggleFilterSearch,
        toggle: toggleFilterSearch,
      },
    );
    return (
      <>
        {/* <div className="breadcrumb-left"> */}
        {/* {+page === 1 ? (
            <Breadcrumb title={keyword} />
          ) : (
            <Breadcrumb title={`${keyword} ${pageText}`} />
          )} */}

        <div className="keywords-filter-wrapper">
          {!Config.isDesignAC() &&
            !Config.isIllustAC() &&
            !isSearchResultImage && (
              <div
                className={refineSearchClassName}
                onClick={() => {
                  this.handleChangeToggleFilterSearch(true);
                }}
              >
                {Config.isIllustAC() && (
                  <div className="icon-open-filter">
                    <FontAwesomeIcon
                      style={{ width: 14 }}
                      icon={faChevronLeft}
                    ></FontAwesomeIcon>
                  </div>
                )}
                <div
                  // onClick={() => {
                  //   this.handleChangeToggleFilterSearch(true);
                  // }}
                  // className="refine-text"
                  className="custom-button-filter"
                >
                  <div className="icon-filter">
                    <IconFilter />
                  </div>
                  <div className="text-filter">{t('filter')}</div>
                </div>
              </div>
            )}
          {!Config.isIllustAC() && (
            <div className="keywords-similar-container">
              <OtherKeywords
                keywords={suggestion}
                toggleFilterSearch={toggleFilterSearch}
                query={this.props.query}
                currentLang={currentLanguage}
                t={t}
              />
            </div>
          )}
        </div>
        {/* </div>
        <div className="breadcrumb-right"> */}
        {/* <PaginationNew
            currentPage={+page}
            totalPage={+totalPage}
            onChange={this.onChangePage}
            query={query}
            path="/search-result"
            asPath="/search-result"
          /> */}
        {/* <div className="personalize-container">
            {this.props.isAuthenticated && Config.serviceType == 'photo_ac' && (
              <div className="personalize-option">
                <label
                  className={`${Config.getPrefix(Config.serviceType)}_label`}
                >
                  <input
                    type="checkbox"
                    id="hasPersonalize"
                    name="hasPersonalize"
                    checked={this.props.hasPersonalize}
                    onChange={this.onSelectPersonalizeSearch}
                  />
                  <b
                    style={{
                      width: 22,
                      height: 22,
                      borderRadius: 2,
                    }}
                  />
                </label>
                <span style={{ marginLeft: 5 }}>{t('personalize')}</span>
              </div>
            )}
          </div> */}
        {/* </div> */}
        <style jsx>
          {`
            // .breadcrumb-wrapper {
            //   display: flex;
            //   flex-direction: column;
            //   width: 100%;
            //   gap: 16px;
            // }
            // .personalize-container {
            //   margin-left: 32px;
            //   height: 44px;
            //   display: flex;
            //   flex-direction: column;
            //   justify-content: center;
            // }

            .keywords-filter-wrapper {
              display: flex;
              flex-direction: row;
              align-items: center;
              flex-wrap: nowrap;
              flex-shrink: 0;
              width: ${Config.isIllustAC() ? '100%' : '75%'};
              margin-top: 8px;
              display: flex;
              justify-content: space-between;
            }
            .keywords-similar-container {
              width: 100%;
            }
            // .breadcrumb-left {
            //   width: 100%;
            //   display: flex;
            //   flex-direction: row;
            //   align-items: center;
            //   flex-wrap: nowrap;
            // }

            // .breadcrumb-right {
            //   width: 100%;
            //   display: flex;
            //   flex-direction: row;
            //   align-items: stretch;
            // }

            .personalize-option {
              margin-right: 8px;
              white-space: nowrap;
              display: flex;
              flex-direction: row;
              align-items: center;
              height: fit-content;
            }
            .personalize-option .ill_label input[type='checkbox']:checked ~ b {
              background-image: url(https://static.photo-ac.com/static/assets/svg/acWorks.svg#illust_checkbox);
              background-size: 100%;
            }

            .personalize-option
              .photo_label
              input[type='checkbox']:checked
              ~ b {
              background-image: url(https://static.photo-ac.com/static/assets/svg/acWorks.svg#photo_checkbox);
              background-size: 100%;
            }

            .custom-button-filter {
              display: flex;
            }

            @media (min-width: ${themeVariables.breakpoints.tabletS
                .minWidth}px) {
              .breadcrumb-right {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
              }

              .keywords-filter-wrapper {
                margin-top: 0;
                width: 100%;
              }
            }

            @media (min-width: ${themeVariables.breakpoints.desktopMedium
                .minWidth}px) {
              .breadcrumb-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
              }

              .breadcrumb-right {
                width: calc(100%);
                flex-wrap: nowrap;
                margin-top: 0;
                justify-content: flex-start;
              }
            }
            @media (min-width: ${themeVariables.breakpoints.mobile
                .minWidth}px) {
              .nav-menu-item.refine-search {
                display: none;
              }
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .keywords-similar-container {
                display: none;
              }
              .keywords-similar-container-mobile {
                display: block;
              }
            }
          `}
        </style>
      </>
    );
  }
  getLinkOtherSite(t, totalItem, keyword, lng) {
    const { query, otherServices } = this.props;

    let dataLink = [];

    if (query?.image_token) {
      const linkSeeMore = {
        as: `/search-result?image_token=${query.image_token}`,
        query: { image_token: query.image_token },
      };
      otherServices.map(({ serviceType }) => {
        dataLink.push(Config.getSiteURL(serviceType) + linkSeeMore.as);
      });
      return dataLink;
    }

    let asPath = 'page=1';
    forIn(query, (value, key) => {
      if (
        value &&
        key !== 'page' &&
        key !== 'is_tag' &&
        key !== 'clientIp' &&
        key !== 'keyword'
      ) {
        asPath += `&${key}=${value}`;
      }
    });

    let onSeeMore = {
      as: `/search/${keyword}?${asPath}`,
      query: { ...query, page: 1, is_tag: true },
    };
    otherServices.map(({ serviceType }) => {
      dataLink.push(Config.getSiteURL(serviceType) + onSeeMore.as);
    });
    return dataLink;
  }

  capitalize(s) {
    if (!s) return '';
    return s[0].toUpperCase() + s.slice(1);
  }
  renderDescriptionUnderBreadCrumb(
    t,
    totalItem,
    keyword,
    lng,
    page,
    isFilterSearch,
  ) {
    const linkOtherService = this.getLinkOtherSite(t, totalItem, keyword, lng);

    if (totalItem == 0) {
      if (Config.serviceType === 'design_ac') {
        return null;
      }

      return (
        <div style={{ marginTop: 16 }} className="des-container">
          {!isFilterSearch && (
            <>
              <div className="header-title-action-no-result">
                <h1
                  className="photo-title"
                  style={{ display: 'inline-block', paddingRight: 8 }}
                  dangerouslySetInnerHTML={{
                    __html: t(
                      Config.getPrefixContent(
                        keyword
                          ? 'category_des_h1_new'
                          : Config.isIllustAC()
                          ? 'search_empty_keyword'
                          : 'category_des_h1_new',
                      ),
                      {
                        number: totalItem,
                        keyword: this.capitalize(keyword) || '',
                      },
                    ),
                  }}
                />
              </div>
              <div
                style={{
                  display: 'inline-block',
                  marginTop: 16,
                  marginBottom: 16,
                }}
                dangerouslySetInnerHTML={{
                  __html: t('no_result_search'),
                }}
              ></div>

              <div>
                <a
                  className="link-help-page"
                  href="/help-page"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('go_to_help_page')}
                </a>
              </div>
            </>
          )}
          <style jsx>
            {`
              .des-container {
                display: flex;
                flex-direction: column;
              }
              .photo-title {
                font-weight: 600;
                font-size: 24px;
                line-height: 28px;
                color: #000000;
                margin-top: 21px;
              }
              .link-help-page {
                font-weight: 600;
                font-size: 16px;
                line-height: 28px;
                text-align: center;
                text-decoration-line: underline;
                color: #509bdc;
              }
              .link-help-page:hover {
                text-decoration-line: underline !important;
                opacity: 0.9;
              }
              // .header-title-action-no-result {
              //   display: flex;
              //   justify-content: space-between;
              // }
              @media (max-width: ${themeVariables.breakpoints.mobile
                  .maxWidth}px) {
                .photo-title {
                  font-size: 20px;
                  margin-top: 0;
                }
              }
            `}
          </style>
        </div>
      );
    }

    return (
      Config.serviceType !== 'design_ac' && (
        <div className="des-container">
          <div className="header-title-action">
            {page > 1 && (
              <h1
                className="photo-title"
                style={{ display: 'inline-block', paddingRight: 8 }}
                dangerouslySetInnerHTML={{
                  __html: t(
                    Config.getPrefixContent(
                      keyword
                        ? 'category_des_h1_new'
                        : Config.isIllustAC()
                        ? 'search_empty_keyword'
                        : 'category_des_h1_new',
                    ),
                    {
                      number: totalItem,
                      keyword:
                        this.capitalize(keyword).replace(/\+/g, ' ') || '',
                      page: page,
                    },
                  ),
                }}
              />
            )}
            {(!page || page <= 1) && (
              <h1
                className="photo-title"
                style={{ display: 'inline-block', paddingRight: 8 }}
                dangerouslySetInnerHTML={{
                  __html: t(
                    Config.getPrefixContent(
                      keyword
                        ? 'category_des_h1_new'
                        : Config.isIllustAC()
                        ? 'search_empty_keyword'
                        : 'category_des_h1_new',
                    ),
                    {
                      number: totalItem,
                      keyword:
                        this.capitalize(keyword).replace(/\+/g, ' ') || '',
                    },
                  ),
                }}
              />
            )}
          </div>

          {!Config.isIllustAC() ? (
            <h2
              className="search-result-description"
              dangerouslySetInnerHTML={{
                __html: t(
                  Config.getPrefixContent('search_result_des_span_new'),
                  {
                    number: totalItem,
                    keyword: this.capitalize(keyword).replace(/\+/g, ' ') || '',
                    link1: linkOtherService[0], //TODO: REVIEW
                    link2: linkOtherService[1],
                  },
                ),
              }}
            />
          ) : lng === 'en' ? (
            <div className="description-keyword">
              <h2
                className="search-result-description-first"
                dangerouslySetInnerHTML={{
                  __html: t(
                    Config.getPrefixContent(
                      'search_result_des_span_new_sentence',
                    ),
                    {
                      number: totalItem,
                      keyword:
                        this.capitalize(keyword).replace(/\+/g, ' ') || '',
                      link1: linkOtherService[0], //TODO: REVIEW
                      link2: linkOtherService[1],
                    },
                  ),
                }}
              />
              <h2
                className="search-result-description-second"
                dangerouslySetInnerHTML={{
                  __html: t(
                    Config.getPrefixContent(
                      'search_result_des_span_new_sentence_second',
                    ),
                    {
                      number: totalItem,
                      keyword:
                        this.capitalize(keyword).replace(/\+/g, ' ') || '',
                      link1: linkOtherService[0], //TODO: REVIEW
                      link2: linkOtherService[1],
                    },
                  ),
                }}
              />
            </div>
          ) : (
            <h2
              className="search-result-description"
              dangerouslySetInnerHTML={{
                __html: t(
                  Config.getPrefixContent(
                    'search_result_des_span_new_sentence',
                  ),
                  {
                    number: totalItem,
                    keyword: this.capitalize(keyword).replace(/\+/g, ' ') || '',
                    link1: linkOtherService[0], //TODO: REVIEW
                    link2: linkOtherService[1],
                  },
                ),
              }}
            />
          )}
          <style jsx>
            {`
              .des-container {
                display: flex;
                flex-direction: column;
              }
              .search-result-description-first {
                display: inline-block;
                font-size: 16px;
                margin: 16px 0 0;
              }
              .search-result-description-second {
                display: inline-block;
                font-size: 16px;
                margin: 0 0 16px;
              }
              .search-result-description {
                display: inline-block;
                margin: 16px 0;
                font-size: 16px;
              }
              .photo-title {
                font-weight: 600;
                font-size: 24px;
                line-height: 28px;
                color: #000000;
                margin-top: 21px;
              }
              // .header-title-action {
              //   display: flex;
              //   justify-content: space-between;
              // }
              @media (max-width: ${themeVariables.breakpoints.mobile
                  .maxWidth}px) {
                // flex-direction: row-reverse;
                // display: flex;
                // justify-content: space-between;
                // align-items: center;

                .photo-title {
                  font-size: 20px;
                  margin-top: 0;
                }
                .search-result-description {
                  font-size: 14px;
                  font-weight: 400;
                }
                .description-keyword {
                  display: none;
                }
              }
            `}
          </style>
        </div>
      )
    );
  }

  renderError = () => {
    const {
      t,
      currentLang,
      isAuthenticated,
      profile,
      error,
      errorSearchPhoto,
    } = this.props;
    if (
      error &&
      error.status === 401 &&
      (!isAuthenticated || profile.role === roles.FREE_MEMBER)
    ) {
      const messageKey = isAuthenticated
        ? 'search_limit_one_day'
        : 'search_limit_one_day_guest';
      return (
        <div className="search-limit-error">
          <div
            style={{ padding: '50px 30px', fontSize: 20, fontWeight: 500 }}
            className={`text-center ${Config.getPrefixContent('text-color')}`}
            dangerouslySetInnerHTML={{
              __html: t(messageKey, {
                currentLang,
                ssoLoginURL: `${
                  Config.ssoServerUrl
                }/login?lang=${currentLang}&serviceURL=${encodeURIComponent(
                  process.browser ? window.location.href : '',
                )}`,
              }),
            }}
          />
          {/* <PremiumPromotion /> */}
          {isAuthenticated && (
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <Link language={currentLang} href="/premium">
                <a>
                  <img
                    src={`/static/assets/image/not-found/${Config.serviceType}.png`}
                    className="img-limit-search"
                    alt="Search limit error"
                  />
                </a>
              </Link>
            </div>
          )}
        </div>
      );
    }

    if (errorSearchPhoto) {
      if (errorSearchPhoto.error_status == 401) {
        const messageKey = isAuthenticated
          ? 'search_limit_one_day'
          : 'search_limit_one_day_guest';
        return (
          <div className="search-limit-error">
            <div
              style={{ padding: '50px 30px', fontSize: 20, fontWeight: 500 }}
              className={`text-center ${Config.getPrefixContent('text-color')}`}
              dangerouslySetInnerHTML={{
                __html: t(messageKey, {
                  currentLang,
                  ssoLoginURL: `${
                    Config.ssoServerUrl
                  }/login?lang=${currentLang}&serviceURL=${encodeURIComponent(
                    process.browser ? window.location.href : '',
                  )}`,
                }),
              }}
            />
            {/* <PremiumPromotion /> */}
            {isAuthenticated && (
              <div style={{ textAlign: 'center', marginBottom: 24 }}>
                <Link language={currentLang} href="/premium">
                  <a>
                    <img
                      src={`/static/assets/image/not-found/${Config.serviceType}.png`}
                      className="img-limit-search"
                      alt="Search limit error"
                    />
                  </a>
                </Link>
              </div>
            )}
          </div>
        );
      }
    }

    return (
      <div className="search-limit-error">
        <div
          style={{ padding: '50px 30px', fontSize: 20, fontWeight: 500 }}
          className={`text-center ${Config.getPrefixContent('text-color')}`}
          dangerouslySetInnerHTML={{ __html: t('default_error_description') }}
        />
      </div>
    );
  };

  handleChangePerPage = (data) => {
    this.setState({
      perPage: data,
    });
  };

  onScroll = () => {
    // 68 is height of pagination bar and padding bottom
    if (this.galleryRef.current && this.galleryRef.current.clientHeight) {
      if (
        window.scrollY >
        this.galleryRef.current.clientHeight -
          this.filterBarRef.current.clientHeight
      ) {
        this.setState({
          topPosition:
            this.galleryRef.current.clientHeight -
            this.filterBarRef.current.clientHeight -
            window.scrollY +
            68,
        });
      } else {
        this.setState({
          topPosition: 70,
        });
      }
    }
  };

  render() {
    const {
      photos,
      currentLang,
      totalPage,
      currentLanguage,
      error,
      t,
      query,
      totalItem,
      loading,
      hasNext,
      errorSearchPhoto,
      searchType,
      toggleFilterSearch,
      lng,
      // isAuthenticated,
      profile,
      isCountdownActive,
      suggestion,
      searchState,
      isShowFilterOnHeader,
      router,
      isFromPopularPage,
      pathSlug,
    } = this.props;
    const {
      order_by,
      page,
      per_page,
      keyword,
      // image_token,
      // is_search_by_photo,
    } = query;
    const { topPosition, perPage } = this.state;

    if (error || (searchType == 'byPhoto' && errorSearchPhoto)) {
      return this.renderError();
    }

    const optionsPerPage = [
      {
        label: t(Config.getPrefixContent('select_per_page_item'), {
          perPage: 60,
        }),
        value: 60,
      },
      {
        label: t(Config.getPrefixContent('select_per_page_item'), {
          perPage: 100,
        }),
        value: 100,
      },
      {
        label: t(Config.getPrefixContent('select_per_page_item'), {
          perPage: 120,
        }),
        value: 120,
      },
      {
        label: t(Config.getPrefixContent('select_per_page_item'), {
          perPage: 180,
        }),
        value: 180,
      },
    ];

    const styleSelectPerPage = {
      container: (styles) => ({
        ...styles,
        width: 200,
        borderRadius: 4,
        zIndex: 100,
        marginRight: 10,
        height: 44,
        border: '1px solid #000000',
        color: '#000000',
      }),
      control: (styles) => ({
        ...styles,
        border: 'none',
        height: '100%',
        width: '100%',
        color: '#000000',
      }),
      option: (provided, state) => ({
        ...provided,
        '&:hover': {
          backgroundColor: state.isSelected
            ? themeVariables.color.primary
            : Config.isIllustAC()
            ? '#FBEBED'
            : '#c4c4c4',
          cursor: 'pointer',
        },
        backgroundColor: state.isSelected
          ? themeVariables.color.primary
          : 'white',
      }),
    };

    const OptionPerPage = ({ value, ...props }) => {
      const newQuery = { ...query, per_page: value };
      delete newQuery.clientIp;
      delete newQuery.keyword;
      const queryString = urls.convertToQueryStrings(newQuery);
      return (
        <I18nLink
          href={{ pathname: `/search/${keyword}`, query: newQuery }}
          as={`/search/${keyword}?${queryString}`}
        >
          <a style={{ color: '#000000' }}>
            <components.Option {...props} />
          </a>
        </I18nLink>
      );
    };

    const isDiscountDisplayed =
      profile.role !== roles.PREMIUM &&
      profile.role !== roles.CREATOR &&
      isCountdownActive;
    const {
      color,
      imageType,
      orderBy,
      shape,
      modelCount,
      modelAge,
      license,
      modelRelease,
      category,
      excludeCategory,
      imageId,
    } = searchState;
    const isFilterSearch =
      color !== 'all' ||
      imageType !== '' ||
      orderBy !== SEARCH_RESULT_ORDER.ALL_IMAGES ||
      shape !== 'all' ||
      modelCount !== '-2' ||
      modelAge.length > 0 ||
      license !== '' ||
      modelRelease !== '' ||
      category.length > 0 ||
      excludeCategory.length > 0 ||
      imageId !== ''
        ? true
        : false;
    const isSearchResultImage =
      router.pathname.indexOf('/search-result') !== -1;
    const highlightID = this.props.query?.highlightID;
    return (
      <div className="search-result-page">
        {isDiscountDisplayed && <BannerDiscount />}
        <div
          className={cn('container-result-service', {
            toggle: toggleFilterSearch,
          })}
        >
          {
            <div
              className={cn('refine-container-desktop', {
                toggle: toggleFilterSearch,
              })}
              ref={this.filterBarRef}
              style={{
                top: topPosition,
              }}
            >
              <RefineSearch
                t={t}
                categories={this.props.categories}
                toggle={toggleFilterSearch}
                query={query}
              />
            </div>
          }
          <div
            className={cn('container-service', {
              toggle: toggleFilterSearch,
            })}
            ref={this.galleryRef}
          >
            {lng === 'en' && <NewSurvey t={t} />}
            {Config.isIllustAC() && lng === 'tw' && <Banner />}
            {Config.isPhotoAC() && lng === 'tw' && <Banner />}
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div>
                <div className="top-pagination-wrapper">
                  {this.renderDescriptionUnderBreadCrumb(
                    t,
                    totalItem,
                    keyword,
                    lng,
                    page,
                    isFilterSearch,
                  )}

                  {photos.length >= 1 &&
                    this.renderNavigationAndBreadCrumb(
                      t,
                      currentLanguage,
                      keyword,
                      order_by,
                      page,
                      per_page,
                      totalPage,
                      query,
                    )}
                </div>
                {!isShowFilterOnHeader &&
                  !isSearchResultImage &&
                  Config.isIllustAC() &&
                  !this.state.isTabletS && (
                    <div className="container-refine-search">
                      <RefineSearchNew
                        t={t}
                        categories={this.props.categories}
                        toggle={toggleFilterSearch}
                        query={query}
                      />
                    </div>
                  )}
                <div
                  className="container-fluid"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                  ref={this.photoContainerRef}
                >
                  {photos.length < 1 && isFilterSearch && (
                    <div
                      style={{ padding: '16px 0' }}
                      className="text-center"
                      dangerouslySetInnerHTML={{
                        __html: t(keyConfig.get('no_result_search_page')),
                      }}
                    />
                  )}
                  {photos.length >= 1 && (
                    <div className="gallery-container-service">
                      {Config.isIllustAC() ? (
                        <GalleryIllust
                          images={photos}
                          currentLang={currentLang}
                          lastRowHide={false}
                          // rowHeight={244}
                          prepareLoad={loading}
                          showImageActions
                          api={this.props.api}
                          t={t}
                          profile={profile}
                          toggleFilterSearch={toggleFilterSearch}
                          page={page}
                          highlightID={highlightID}
                        />
                      ) : (
                        <Gallery
                          images={photos}
                          currentLang={currentLang}
                          lastRowHide={false}
                          rowHeight={244}
                          prepareLoad={loading}
                          showImageActions
                          api={this.props.api}
                          t={t}
                          page={page}
                        />
                      )}
                    </div>
                  )}
                  {photos.length >= 1 && (
                    <div className="bottom-pagination">
                      <div className="button-change-page">
                        {hasNext && (
                          <NextPageButtonCustom
                            style={{ marginBottom: 8 }}
                            pathname={`/search/${keyword}`}
                            query={this.onNextPage().query}
                            as={this.onNextPage().as}
                            t={t}
                            label={t('next_page_button')}
                          />
                        )}
                        {totalPage > 1 && !hasNext && (
                          <PreviousPageButtonCustom
                            style={{ marginBottom: 8 }}
                            pathname={`/search/${keyword}`}
                            query={this.onPreviousPage().query}
                            as={this.onPreviousPage().as}
                            t={t}
                            label={t('previous_page')}
                          />
                        )}
                      </div>
                      <div className="select-paginate-wrapper">
                        <Select
                          value={
                            perPage
                              ? perPage
                              : optionsPerPage.filter(
                                  (item) => item.value === +per_page,
                                )
                          }
                          className="select-number-per-page"
                          components={{ Option: OptionPerPage }}
                          options={optionsPerPage}
                          styles={styleSelectPerPage}
                          onChange={this.handleChangePerPage}
                          instanceId="search-result-page-select"
                        />
                        {isFromPopularPage ? (
                          <PaginationStaticPage
                            currentPage={+page}
                            totalPage={+totalPage}
                            path={`/${
                              Config.isIllustAC()
                                ? 'free-illustrations-vectors/'
                                : 'popular-page/'
                            }`}
                            asPath={`/${
                              Config.isIllustAC()
                                ? 'free-illustrations-vectors/'
                                : 'popular-page/'
                            }${pathSlug}`}
                          />
                        ) : (
                          <PaginationNew
                            currentPage={+page}
                            totalPage={+totalPage}
                            onChange={this.onChangePage}
                            query={query}
                            path={`/search/${keyword}`}
                            asPath={`/search/${keyword}`}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  {/* move similar keyword from top to bottom */}
                  {Config.isIllustAC() && (
                    <div className="keywords-similar-container">
                      <OtherKeywords
                        keywords={suggestion}
                        toggleFilterSearch={toggleFilterSearch}
                        query={this.props.query}
                        currentLang={currentLanguage}
                        t={t}
                      />
                    </div>
                  )}
                  <div className="keywords-similar-container-mobile">
                    <OtherKeywords
                      keywords={suggestion}
                      toggleFilterSearch={toggleFilterSearch}
                      query={this.props.query}
                      currentLang={currentLanguage}
                      t={t}
                    />
                  </div>
                  {photos.length < 1 && <TagTrending />}
                </div>
              </div>
            )}
          </div>
        </div>{' '}
        {/* container-result-service */}
        <div
          className={cn('refine-container-mobile', {
            toggle: toggleFilterSearch,
          })}
        >
          <RefineSearch
            t={t}
            categories={this.props.categories}
            toggle={toggleFilterSearch}
            query={query}
          />
        </div>
        <OtherServices t={t} keyword={keyword.toLowerCase()} />
        {/* {!isAuthenticated && <SEOTextACworksCustom />} */}
        {/* {!isAuthenticated && <SEOTextACworks />} */}
        <style jsx>
          {`
            .container-refine-search {
              padding: 0 16px;
            }
            .title-head {
              background: #666;
              padding: 8px;
              font-size: 16px;
            }

            .bottom-pagination {
              position: relative;
              width: 100%;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              margin: 16px 0;
              // padding-left: 20px;
              // padding-right: 24px;
            }

            .select-paginate-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .top-pagination-wrapper {
              width: 100%;
              background: #fff;
              padding: 0px 16px;
              display: flex;
              flex-direction: column;
              align-items: stretch;
            }
            .keywords-similar-container-mobile {
              display: none;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .keywords-similar-container {
                display: none;
              }
              .keywords-similar-container-mobile {
                display: block;
              }
              .container-refine-search {
                display: none;
              }
              .bottom-pagination {
                flex-direction: column;
              }
              .pagination-service {
                position: relative;
                margin-top: 16px;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .link-to {
              color: ${themeVariables.colors.primary};
            }
            .link-to:hover {
              color: ${themeVariables.colors.primary};
              opacity: 0.9;
            }
            .refine-container-mobile {
              display: none;
            }
            .input-text-filter {
              border: 1px solid #f2f3f4;
              box-shadow: none;
              height: 40px;
              ${Config.isIllustAC()
                ? 'border-radius: 40px; '
                : 'border-radius: 4px; background: #f2f3f4;'}
            }

            .gallery-container-service {
              margin-top: 12px;
              width: 100%;
              // max-height: 2000px;
              height: fit-content;
              // padding: 16px;
              // overflow: hidden;
              // overflow-y: scroll;
              // background: #f8f9fa;
            }
            .text-refine-search,
            .text-filter {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              font-weight: 600;
              font-size: ${Config.isIllustAC() ? '14px' : '16px'};
              margin-left: 4px;
            }
            @media (min-width: ${themeVariables.breakpoints.tabletS
                .minWidth}px) {
              .text-refine-search {
                display: none;
              }
            }
            .search-result-page {
              width: 100%;
              background: #fff;
              // padding-bottom: 80px;
            }
            .main-service-result {
              width: 100%;
            }

            .container-result-service {
              width: 100%;
              display: flex;
              flex-direction: row;
              align-items: stretch;
              flex-wrap: nowrap;
              min-height: 800px;
            }

            .refine-container-desktop {
              position: relative;
              top: 0;
              z-index: 800;
              width: 0;
              overflow: scroll;
            }

            .refine-container-desktop.toggle {
              width: 308px;
              overflow-y: auto;
              position: fixed;
              height: 100%;
              transition: all 0.3s ease-out;
              z-index: 1;
              border-right: 1px solid #c4c4c4;
            }
            .container-service {
              max-width: 100%;
              flex: 1;
              margin-left: 0;
            }

            .container-service.toggle {
              width: calc(100% - 308px);
              margin-left: 308px;
              position: relative;
              min-height: 1200px;
            }

            .search-result-page .filter-item {
              display: flex;
              min-width: 350px;
            }

            .search-result-page .filter-title {
              flex-basis: 0;
              flex-grow: 1;
            }

            .search-result-page .filter-content {
              flex-basis: 0;
              flex-grow: 2;
              display: flex;
            }

            .search-limit-error {
              margin-bottom: 390px;
            }
            .search-limit-error .premium-promotion {
              font-size: 20px;
              margin-bottom: 28px;
            }
            .nav-menu-item.refine-search {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              font-size: 18px;
              cursor: pointer;
              width: 230px;
              height: 44px;
              display: flex;
              padding: 0px;
              border: 2px solid #1b2833;
              box-sizing: border-box;
              border-radius: 4px;
              color: #1b2833;
              left: -10px;
              min-width: 100px;
            }
            .nav-menu-item.refine-search.photo_ac:hover {
              opacity: 0.9;
            }
            .nav-menu-item.refine-search.photo_ac {
              color: #ffffff;
              background-color: ${themeVariables.colors.primary};
              border: none;
              min-width: 100px;
              display: flex;
              justify-content: center;
            }
            .nav-menu-item.refine-search.illust_ac {
              width: 240px;
              height: 40px;
              padding: 8px 16px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              background: #d73a4e;
              border-radius: 40px;
              color: #ffffff;
              border: none;
              align-self: start;
              top: 4px;
            }
            .nav-menu-item.refine-search.illust_ac:hover {
              opacity: 0.9;
            }
            .nav-menu-item.refine-search.silhouette_ac:hover {
              border-color: #41b9b8;
              color: #41b9b8;
            }
            .nav-menu-item.refine-search.silhouette_ac:hover {
              border-color: #ffa823;
              color: #ffa823;
            }
            .nav-menu-item.refine-search.toggle {
              display: none;
              transition: display 0.4;
            }

            @media only screen and (max-width: 1024px) {
              .nav-menu-item.refine-search {
                width: 180px;
              }
            }
            @media (max-width: ${themeVariables.breakpoints.tabletL
                .maxWidth}px) {
              .text-filter {
                display: none;
              }
              .search-result-page .breadcrumb-wrapper {
                flex-wrap: wrap;
                justify-content: flex-end;
                max-width: 100%;
              }
              .search-result-page .breadcrumb-wrapper .pagination-right {
                max-width: 100%;
                margin-top: 12px;
              }
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .container-result-service {
                display: block;
              }
              .icon-open-filter {
                display: none;
              }
              .nav-menu-item.refine-search.illust_ac {
                justify-content: center;
              }
              .select-number-per-page {
                margin-bottom: 10px;
              }
              .nav-menu-item.refine-search {
                // right: -10px;
                left: unset;
                display: none !important;
              }
              .refine-container-desktop {
                display: none;
              }
              .button-change-page {
                display: none;
              }
              .select-paginate-wrapper {
                flex-wrap: wrap;
              }
              .refine-container-mobile {
                z-index: 999;
                position: fixed;
                width: 100%;
                height: 100%;
                display: block;
                top: 60px;
                left: 100%;
                animation: closeFilterMobile 0.4s ease-out forwards;
              }
              .refine-container-mobile.toggle {
                max-width: 100%;
                top: 0;
                left: 0;
                animation: openFilterMobile 0.4s ease-out forwards;
              }
              .gallery-container-service {
                display: block;
                max-height: fit-content;
                height: fit-content;
                padding: 0;
              }
              .photo-title {
                font-size: 18px !important;
                font-weight: 600 !important;
              }
              h2 {
                font-size: 14px !important;
              }
              .keywords-filter-wrapper {
                flex-direction: column !important;
              }
              .container-service {
                overflow: hidden;
              }
            }

            @keyframes openFilterMobile {
              0% {
                transform: translateX(100%);
              }
              100% {
                transform: translateX(0);
              }
            }
            @keyframes closeFilterMobile {
              0% {
                transform: translateX(100%);
              }
              100% {
                transform: translateX(0);
              }
            }

            .search-dropdown-design_ac__multi-value {
              background: #ffa823;
            }

            .search-dropdown-design_ac__multi-value
              .search-dropdown-design_ac__multi-value__label {
              color: #fff;
            }

            .search-dropdown-design_ac__multi-value
              .search-dropdown-design_ac__multi-value__remove {
              color: #fff;
            }
            .search-dropdown-illust_ac__multi-value {
              background: #d73a4e;
            }

            .search-dropdown-illust_ac__multi-value
              .search-dropdown-illust_ac__multi-value__label {
              color: #fff;
            }

            .search-dropdown-illust_ac__multi-value
              .search-dropdown-illust_ac__multi-value__remove {
              color: #fff;
            }
            .search-dropdown-silhouette_ac__multi-value {
              background: #41b9b8;
            }

            .search-dropdown-silhouette_ac__multi-value
              .search-dropdown-silhouette_ac__multi-value__label {
              color: #fff;
            }

            .search-dropdown-silhouette_ac__multi-value
              .search-dropdown-silhouette_ac__multi-value__remove {
              color: #fff;
            }
            .search-dropdown-photo_ac__multi-value {
              background: #509bdc;
            }

            .search-dropdown-photo_ac__multi-value
              .search-dropdown-photo_ac__multi-value__label {
              color: #fff;
            }

            .search-dropdown-photo_ac__multi-value
              .search-dropdown-photo_ac__multi-value__remove {
              color: #fff;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  patterns: makeSelectPatterns(),
  currentLanguage: makeSelectCurrentLanguage(),
  photos: makeSelectPhotos(),
  currentLang: makeSelectCurrentLang(),
  error: makeSelectError(),
  categories: makeSelectCategories(),
  page: makeSelectPage(),
  totalPage: makeSelectTotalPage(),
  totalItem: makeSelectTotalItem(),
  orderBy: makeSelectOrderBy(),
  perPage: makeSelectPerPage(),
  loading: makeSelectLoading(),
  query: makeSelectQuery(),
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
  hasNext: makeSelectHasNext(),
  hasPersonalize: makeSelectHasPersonalize(),
  toggleFilterSearch: makeSelectToggleFilterSearch(),
  suggestion: makeSelectSuggestion(),
  otherServices: makeSelectOtherServices(),
  isCountdownActive: makeSelectIsCountdownActive(),
  searchState: selectSearch,
  isShowFilterOnHeader: makeSelectIsShowFilterOnHeader(),
});
const mapDispatchToProps = (dispatch) => ({
  loadDataSearch: (query) => dispatch(loadDataSearch(query)),
  searchPhoto: (query) => dispatch(searchPhoto(query)),
  searchOtherServices: (query) => dispatch(searchOtherServices(query)),
  changeOrder: (value) => dispatch(changeOrder(value)),
  changePage: (page) => dispatch(changePage(page)),
  changePersonalize: (hasPersonalize) =>
    dispatch(changePersonalize(hasPersonalize)),
  changePerPage: (value) => dispatch(changePerPage(value)),
  loadingHide: () => dispatch(loadingHide()),
  loadingShow: (params) => dispatch(loadingShow(params)),
  onToggleFilterSearch: (value) => {
    dispatch(changeToggleFilterSearch(value));
  },
  loadPhotosInCart: () => dispatch(loadPhotosInCart()),
  openAllFilter: () => dispatch(openAllFilter()),
  changeOpenMore: () => dispatch(changeOpenMore()),
  closeAllFilter: () => dispatch(closeAllFilter()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchResultContainer);
